module.exports = __webpack_public_path__ + "img/1.c92c3deb.jpg";